import React from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { LoadingContainer } from "go-core/components/Loading";
import { OrganizationApi, OrganizationFeatureApi, UserRole } from "../../../../../../services/Api/types";
import OrganizationProductCategoryChartItem from "./Products/OrganizationProductCategoryChartItem";

interface Props {
	features?: OrganizationFeatureApi[];
	organization: OrganizationApi;
	loading: boolean;
	areAllowed: (contexts: Record<string, UserRole[]>) => boolean;
	onEdit: () => void;
	url: string;
}

const OrganizationFeaturesCard = (props: Props) => {
	const { t } = useTranslation("admin");

	const stats = props.organization.stats;
	return (
		<Card className="organization-products-card">
			<Card.Body>
				<h5 className={"d-flex justify-content-between align-items-center"}>
					{t("enums.organization.card_type.FEATURES")}
					<Link to={`${props.url}/features`} className={"btn btn-sm btn-default"}>
						Pokaż
					</Link>
				</h5>
				{props.loading ? (
					<LoadingContainer />
				) : (
					<>
						<React.Fragment>
							<div className="d-flex flex-column organization-products-card-item">
								<h6 className="text-primary">Funkcje</h6>
								<div className="d-flex flex-column gap-2">
									<OrganizationProductCategoryChartItem
										value={stats.feature_count}
										title={"Ilość"}
										percentValue={stats.feature_percent}
										potentialValue={stats.feature_potential_count}
										currency={"PLN"}
									/>
									<OrganizationProductCategoryChartItem
										value={stats.feature_points}
										title={"Punkty"}
										percentValue={stats.feature_points_percent}
										potentialValue={stats.feature_potential_points}
										currency={"PLN"}
									/>
								</div>
							</div>
						</React.Fragment>
					</>
				)}
			</Card.Body>
		</Card>
	);
};

export default OrganizationFeaturesCard;
